import { throttleTime } from "rxjs/operators";
import { AfterViewInit, Component, EventEmitter, Input, Output } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { CoreStoreFacade } from "@modules/+new/core/core-store/domain/+state/core-store.facade";

@UntilDestroy()
@Component({
	selector: "loading-button",
	templateUrl: "./loading-button.component.html",
	standalone: false
})
export class LoadingButtonComponent implements AfterViewInit {
	@Input("type") public _type = "button";
	@Input("disabled") public _disabled: boolean = false;
	@Input("loading") public _loading: boolean;
	@Input("text") public _text: string = "default_text";
	@Input("styles") public _styles: string = "";
	@Input("buttonStyle") public _buttonStyle: string;
	@Input("tabindex") public _tabIndex: number;
	@Input("throttleTime") public _throttleTime = 1000; // 1 second
	@Output("onClick") public _emitter: EventEmitter<void> = new EventEmitter();

	private callActionSubject = new Subject<void>();
	private callActionObservable: Observable<void>;

	public constructor(private readonly coreStoreFacade: CoreStoreFacade) {}

	public ngAfterViewInit(): void {
		// Won't let the user click several times the same button (added click throttle)
		this.callActionObservable = this.callActionSubject.asObservable().pipe(throttleTime(this._throttleTime));
		this.callActionObservable.pipe(untilDestroyed(this)).subscribe(() => {
			if (!this.disabled) {
				this._emitter.emit();
			}
		});
	}

	public callAction(): void {
		this.callActionSubject.next();
	}

	public get loading(): boolean {
		if (this._loading !== null) {
			return this._loading;
		}
		return this.coreStoreFacade.coreStoreSnapshot.isApiLoading;
	}

	public get text(): string {
		return this._text;
	}

	public get styles(): string {
		return this._styles;
	}

	public get type(): string {
		return this._type;
	}

	public get buttonStyle(): string {
		return this._buttonStyle;
	}

	public get disabled(): boolean {
		return this._disabled;
	}

	public get tabIndex(): number {
		return this._tabIndex;
	}
}
